"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUtils = exports.getStore = exports.getCONSTANTS = exports.useConstants = exports.useStore = exports.useACContext = exports.ACWrapperContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
// Create React context
var ACContext = (0, react_1.createContext)({
    store: null,
    constants: null,
    utils: null,
});
// Module-level variables as a fallback
var storeInstance = null;
var constantsInstance = null;
var utilsInstance = null;
var ACWrapperContext = function (_a) {
    var children = _a.children, props = _a.props;
    // Set module-level variables as fallback
    storeInstance = (props === null || props === void 0 ? void 0 : props.store) || null;
    constantsInstance = (props === null || props === void 0 ? void 0 : props.constants) || null;
    utilsInstance = (props === null || props === void 0 ? void 0 : props.utils) || null;
    // Provide context values to children
    return ((0, jsx_runtime_1.jsx)(ACContext.Provider, { value: {
            store: (props === null || props === void 0 ? void 0 : props.store) || null,
            constants: (props === null || props === void 0 ? void 0 : props.constants) || null,
            utils: (props === null || props === void 0 ? void 0 : props.utils) || null,
        }, children: children }));
};
exports.ACWrapperContext = ACWrapperContext;
// Hook for use ONLY inside React components
var useACContext = function () {
    return (0, react_1.useContext)(ACContext);
};
exports.useACContext = useACContext;
// Hook versions - use these inside React components
var useStore = function () {
    var context = (0, react_1.useContext)(ACContext);
    return context.store;
};
exports.useStore = useStore;
var useConstants = function () {
    var context = (0, react_1.useContext)(ACContext);
    return context.constants;
};
exports.useConstants = useConstants;
// Non-hook getter functions - safe to use anywhere
var getCONSTANTS = function () {
    // Only return the module-level variable
    return constantsInstance;
};
exports.getCONSTANTS = getCONSTANTS;
var getStore = function () {
    // Only return the module-level variable
    return storeInstance;
};
exports.getStore = getStore;
var getUtils = function () {
    return utilsInstance;
};
exports.getUtils = getUtils;
